import React from "react";
import {
  Select,
  MenuItem,
  SelectProps,
  Box,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import { userDetailsSelector } from "../../store/account/selector";
import { changeTeamLoadingSelector } from "../../store/metadata/selector";

// Extend the SelectProps to include our custom props
interface StyledSelectProps extends Omit<SelectProps, "onChange"> {
  onChange: (value: string) => void;
}

// Create the custom Select component
const TeamSelectDropdown: React.FC<StyledSelectProps> = ({
  onChange,
  ...props
}) => {
  const userCurrentTeamDetail = useSelector(userDetailsSelector);
  const isLoading = useSelector(changeTeamLoadingSelector);

  return (
    <Select
      value={userCurrentTeamDetail?.currentTeamId || ""}
      onChange={(event) => onChange(event.target.value as string)}
      MenuProps={{
        PaperProps: {
          sx: {
            padding: "0 !important",
            "& .MuiList-root": {
              padding: "0 !important",
            },
          },
        },
      }}
      displayEmpty
      renderValue={(selected) => (
        <Box display="flex" alignItems="center" gap={1}>
          {isLoading ? <CircularProgress size={16} /> : null}
          {userCurrentTeamDetail?.userTeams?.find(
            (team: any) => team._id === selected
          )?.name || "Select Team"}
        </Box>
      )}
      {...props}
    >
      {userCurrentTeamDetail?.userTeams?.map(
        (item: { _id: string; name: string }) => {
          return (
            <MenuItem key={item._id} value={item._id}>
              {item.name}
            </MenuItem>
          );
        }
      )}
    </Select>
  );
};

export default TeamSelectDropdown;
